<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card class="profile">
            <v-toolbar :color="toolbarColor" flat>
                <v-btn icon @click="closeDialogEdit()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Edit Applicant - {{ item.firstName }} {{ item.lastName}} </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn text @click="closeDialogEdit()">Close</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-row justify="center">
                    <v-col cols="12" lg="4">
                        <v-card class="fill-height" elevation="3">
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <v-avatar size="200" tile>
                                            <v-card class="avatar__card" :loading="avatarLoad">
                                                <v-img v-if="avatar"
                                                    lazy-src="../../../assets/admin/applicants/other_avatar-min.png"
                                                    :src="getPhotoSrc()">
                                                </v-img>
                                                <v-img v-else-if="item.gender == 'M'"
                                                    src="../../../assets/admin/applicants/male_avatar-min.jpg">
                                                </v-img>
                                                <v-img v-else-if="item.gender == 'F'"
                                                    src="../../../assets/admin/applicants/female_avatar-min.jpg">
                                                </v-img>
                                                <v-img v-else
                                                    src="../../../assets/admin/applicants/other_avatar-min.png">
                                                </v-img>
                                            </v-card>
                                        </v-avatar>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col class="profile-label py-0" cols="12" md="6">
                                                Name
                                            </v-col>
                                            <v-col class="profile-sublabel text-md-end" cols="12" md="6">
                                                {{ item.firstName }} {{ item.lastName }}
                                            </v-col>
                                            <v-col class="profile-label py-0" cols="12" md="6">
                                                Student Number
                                            </v-col>
                                            <v-col class="profile-sublabel pt-0 text-md-end" cols="12" md="6">
                                                {{ item.studentnumber }}
                                            </v-col>
                                            <v-col class="profile-label py-0" cols="12" md="6">
                                                Applicant Role
                                            </v-col>
                                            <v-col class="profile-sublabel pt-0 text-md-end" cols="12" md="6">
                                                {{ item.applicantRole == "residenceAssistant" ? "Residence Assistant" : "Student" }}
                                            </v-col>
                                            <v-col class="profile-label py-0" cols="12" md="6">
                                                Email
                                            </v-col>
                                            <v-col class=" profile-sublabelpt-0 text-md-end" cols="12" md="6">
                                                <a :href="`mailto:${item.email}`">{{ item.email }}</a>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-tabs v-model="tab" :color="infoColor" vertical>
                                            <v-tab>
                                                <v-icon left small>mdi-account</v-icon> Personal Information
                                            </v-tab>
                                            <v-tab>
                                                <v-icon left small>mdi-card-account-mail</v-icon> Emergency Contact
                                            </v-tab>
                                            <v-tab>
                                                <v-icon left small>mdi-home-group</v-icon> Building Preference
                                            </v-tab>
                                            <v-tab>
                                                <v-icon left small>mdi-hand-heart</v-icon> Accommodation
                                                Consideration(s)
                                            </v-tab>
                                            <v-tab v-if="item.applicantRole == 'residenceAssistant'">
                                                <v-icon left small>mdi-information</v-icon> General Information
                                            </v-tab>
                                            <v-tab v-else>
                                                <v-icon left small>mdi-home-edit</v-icon> Placement Preference
                                            </v-tab>
                                        </v-tabs>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="8">
                        <v-card elevation="3">
                            <v-card-text v-if="item.applicantRole == 'residenceAssistant'">
                                <v-alert v-if="!valid" text prominent type="error" icon="mdi-alert">
                                    There are one or more required form fields that are empty. Please verify that all
                                    required form fields
                                    are filled in and valid.
                                </v-alert>
                                <v-form ref="editApplicantForm" v-model="valid" lazy-validation>
                                    <v-tabs-items v-model="tab">
                                        <v-tab-item>
                                            <applicant-personal-information :formSettings="formSettings" :item="item"
                                                :residenceTermsAppliedTo="residenceTermsAppliedTo">
                                            </applicant-personal-information>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-emergency-contact-information :item="item">
                                            </applicant-emergency-contact-information>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-ra-building-preference :formSettings="formSettings" :item="item">
                                            </applicant-ra-building-preference>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-accommodation-consideration :item="item">
                                            </applicant-accommodation-consideration>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-ra-general-information :item="item"
                                                @addTrainingDayMissed="addTrainingDayMissed"
                                                @removeTrainingDayMissed="removeTrainingDayMissed">
                                            </applicant-ra-general-information>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-form>
                            </v-card-text>
                            <v-card-text v-else>
                                <v-alert v-if="!valid" text prominent type="error" icon="mdi-alert">
                                    There are one or more required form fields that are empty. Please verify that all
                                    required form fields
                                    are filled in and valid.
                                </v-alert>
                                <v-form ref="editApplicantForm" v-model="valid" lazy-validation>
                                    <v-tabs-items v-model="tab">
                                        <v-tab-item>
                                            <applicant-personal-information :formSettings="formSettings" :item="item"
                                                :residenceTermsAppliedTo="residenceTermsAppliedTo">
                                            </applicant-personal-information>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-emergency-contact-information :item="item">
                                            </applicant-emergency-contact-information>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-building-preference :formSettings="formSettings" :item="item"
                                                @resetBuildingOption1="resetBuildingOption1"
                                                @resetBuildingOption2="resetBuildingOption2"
                                                @resetRoommateOption1="resetRoommateOption1"
                                                @resetRoommateOption2="resetRoommateOption2">
                                            </applicant-building-preference>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-accommodation-consideration :item="item">
                                            </applicant-accommodation-consideration>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <applicant-placement-preference :item="item">
                                            </applicant-placement-preference>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-form>
                            </v-card-text>
                            <v-card-actions class="pb-4 pt-0 px-5">
                                <v-spacer></v-spacer>
                                <v-btn ref="saveBtn" class="white--text" :color="successColor" :disabled="!valid"
                                    @click="editApplicant">
                                    Save
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import ApplicantBuildingPreference from './Edit/BuildingPreference';
import ApplicantAccommodationConsideration from './Edit/AccommodationConsideration';
import ApplicantEmergencyContactInformation from './Edit/EmergencyContactInformation';
import ApplicantPersonalInformation from './Edit/PersonalInformation';
import ApplicantPlacementPreference from './Edit/PlacementPreference';
import ApplicantRaBuildingPreference from './Edit/ResidenceAssistant/BuildingPreference';
import ApplicantRaGeneralInformation from './Edit/ResidenceAssistant/GeneralInformation';

export default {
    name: 'applicant-edit',
    components: {
        ApplicantBuildingPreference,
        ApplicantAccommodationConsideration,
        ApplicantEmergencyContactInformation,
        ApplicantPersonalInformation,
        ApplicantPlacementPreference,
        ApplicantRaBuildingPreference,
        ApplicantRaGeneralInformation
    },
    props: {
        avatar: {
            required: true
        },
        dialog: {
            required: true,
            type: Boolean
        },
        item: {
            required: true,
            type: Object
        },
        formSettings: {
            required: true
        },
        permission: {
            required: true,
            type: Object
        },
        residenceTermsAppliedTo: {
            required: true
        }
    },
    data() {
        return {
            avatarLoad: true,
            tab: null,
            valid: true
        }
    },
    methods: {
        addTrainingDayMissed(item) {
            this.$emit('addTrainingDayMissed', item);
        },
        closeDialogEdit() {
            this.$emit('closeDialogEdit');
        },
        editApplicant() {
            if (this.$refs.editApplicantForm.validate()) {
                this.$refs.saveBtn.loading = true;
                this.$emit('editApplicant');
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.saveBtn.loading = false;
                    }, 1000);
                });
            }
        },
        getCurrentApplicant() {
            this.$emit('getCurrentApplicant');
        },
        getPhotoSrc() {
            if (this.avatar) {
                return `data:image/jpeg;base64,${this.avatar}`
            }

            return '';
        },
        refreshData() {
            this.$emit('refreshData');
        },
        removeTrainingDayMissed(index) {
            this.$emit('removeTrainingDayMissed', index);
        },
        resetTab() {
            this.tab = null;
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        },
        resetBuildingOption1() {
            this.$emit('resetBuildingOption1');
        },
        resetBuildingOption2() {
            this.$emit('resetBuildingOption2');
        },
        resetRoommateOption1() {
            this.$emit('resetRoommateOption1');
        },
        resetRoommateOption2() {
            this.$emit('resetRoommateOption2');
        },
        setAvatarLoad(bool) {
            this.avatarLoad = bool;
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        kingsGold() {
            return '#d7ae28';
        },
        successColor() {
            return '#1bc5bd';
        },
        toolbarColor() {
            return '#FFA800';
        }
    },
    created() {
        if (this.item.applicantRole == "residenceAssistant") {
            this.item.allergiesType ? this.item.allergiesType : [];
        }
    }
}
</script>

<style scoped>
.avatar__card {
    padding-top: 5px;
}

.profile {
    background: #eef0f8;
}

.profile-label {
    font-weight: 600;
}

.profile-sublabel {
    color: #6d6e71;
    font-size: 14px;
    font-weight: 500;
}

.v-tab {
    margin: 0 auto;
}
</style>